'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.formatTime = formatTime;

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../../core/view');

var _view2 = _interopRequireDefault(_view);

var _time = require('./time.scss');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function formatTime(seconds) {
  var date = new Date(null);
  seconds = isNaN(seconds) || !isFinite(seconds) ? 0 : Math.floor(seconds);
  date.setSeconds(seconds);

  // get HH:mm:ss part, remove hours if they are "00:"
  return date.toISOString().substr(11, 8).replace(/^00:/, '');
}

var TimeView = function (_View) {
  _inherits(TimeView, _View);

  function TimeView(config) {
    _classCallCheck(this, TimeView);

    var _this = _possibleConstructorReturn(this, (TimeView.__proto__ || Object.getPrototypeOf(TimeView)).call(this, config));

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['time-wrapper'],
      'data-hook': 'time-control'
    });

    _this.$currentTime = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.current + ' ' + _this.styleNames.time,
      'data-hook': 'current-time-indicator'
    });

    _this.$divider = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.time
    }).html('/');

    _this.$durationTime = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.duration + ' ' + _this.styleNames.time,
      'data-hook': 'duration-time-indicator'
    });

    _this.$node.append(_this.$currentTime).append(_this.$divider).append(_this.$durationTime);
    return _this;
  }

  _createClass(TimeView, [{
    key: 'setState',
    value: function setState(_ref) {
      var duration = _ref.duration,
          current = _ref.current;

      duration !== undefined && this._setDurationTime(duration);
      current !== undefined && this._setCurrentTime(current);
    }
  }, {
    key: '_setDurationTime',
    value: function _setDurationTime(duration) {
      this.$durationTime.html(formatTime(duration));
    }
  }, {
    key: '_setCurrentTime',
    value: function _setCurrentTime(current) {
      this.$currentTime.html(formatTime(current));
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.$node.remove();

      delete this.$currentTime;
      delete this.$divider;
      delete this.$durationTime;
      delete this.$node;
    }
  }]);

  return TimeView;
}(_view2.default);

TimeView.extendStyleNames(_time2.default);

exports.default = TimeView;
//# sourceMappingURL=time.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/time/time.view.js
// module id = 1700
// module chunks = 1 2 3